import { useEffect } from "react";
import { useCurrentUser } from "./context/UserContext";

const SCRIPT_SRC = "//js.hs-scripts.com/4192062.js" as const;
const SCRIPT_ID = "hs-script-loader";

export default function HubspotScriptManager() {
  const isAuthenticated = !!useCurrentUser()?.id;

  useEffect(() => {
    if (!isAuthenticated || document.getElementById(SCRIPT_ID)) return;

    // eslint-disable-next-line sonarjs/disabled-resource-integrity
    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.id = SCRIPT_ID;

    document.body.appendChild(script);

    return () => {
      document.getElementById(SCRIPT_ID)?.remove();
    };
  }, [isAuthenticated]);

  return null;
}
